export const getDigitsOnly = (value: string = '') =>
  typeof value === 'string' ? value.replace(/[^0-9]/g, '') : ''
